// fullExtentTool

import Extent = require("esri/geometry/Extent");
import ToolButton from "./toolButton";

export const illinoisExtent = new Extent({
  ymin: 36.8,
  ymax: 42.7,
  xmin: -91.7,
  xmax: -86.8
});

export default class FullExtentTool extends ToolButton {
  deactivateTool() {
    // console.log("FullExtentTool deactivateTool")
  }

  activateTool(event: any) {
    // console.log("fullExtentTool start : view = ", view)
    try {
      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        this.view.goTo(illinoisExtent);
      }
      this.toolbar.setPanAsActiveTool();
    } catch (error) {
      console.error("Error: in fullExtentTool " + +error.message);
    }
  }
}
